import MobilityContractPayoutConfigsService from "../../services/crud/MobilityContractPayoutConfigService";
import { TableProps } from "./types";
import GenericItemsTable, { DefaultColumnMapper } from "./GenericItemsTable";
import { MobilityContractPayoutConfigFormGenericForm } from "../forms/MobilityContractPayoutConfigForm";
import MobilityContractPayoutConfig from "../../models/MobilityContractPayoutConfig";
import { formatPriceInCents } from "../../utils/common";
import { useContext } from "react";
import { NavigationContext } from "../../context/NavigationContext";
import { Modes } from "../../Modes";

async function load(accountId: number): Promise<MobilityContractPayoutConfig[]> {
  return await MobilityContractPayoutConfigsService.listOnAccount(accountId);
}

export const GenericMobilityContractPayoutConfigsTable = ({ accountId, ...rest }: TableProps<MobilityContractPayoutConfig>&{accountId: number}) => {
  const { mode } = useContext(NavigationContext);
  const sysAdmin = mode === Modes.SYSTEM_ADMIN;

  return (
    <GenericItemsTable
      actions={{ select: sysAdmin, edit: sysAdmin, delete: false }}
      hideButtons={!sysAdmin}
      hideActions={!sysAdmin}
      excludeColumns={[
        "id",
        "accountId",
        "updatedAt",
        "createdAt",
        ... sysAdmin ? [] : ["actions"],
      ]}
      model={MobilityContractPayoutConfig}
      name="Mobilitet"
      form={MobilityContractPayoutConfigFormGenericForm}
      formCreate={MobilityContractPayoutConfigFormGenericForm}
      formEdit={MobilityContractPayoutConfigFormGenericForm}
      onAdd={(data) => MobilityContractPayoutConfigsService.addMobilityContractPayoutConfig({
        ...data,
        accountId: accountId,
      } as MobilityContractPayoutConfig)}
      onEdit={(data) => MobilityContractPayoutConfigsService.editMobilityContractPayoutConfig(data.id, data)}
      service={MobilityContractPayoutConfigsService}
      dataLoader={async () => await load(accountId)}
      columnMapper={(col) => {
        col = DefaultColumnMapper(col);
        if (col.key == 'walletPayoutAmountCents') {
          col.title = 'Wallet Payout (kr)';
          col.render = (text, record, index) => {
            const amountKr = formatPriceInCents(record?.walletPayoutAmountCents, null);
            return amountKr;
          }
        } else if (col.key == 'maxMobilityContractPayoutsPerApartment') {
          col.title = 'Max contract payouts per apartment';
        }
        return col;
      }}
      {...rest}></GenericItemsTable>
  );
};

